import { Option } from "../../models/option";

export const tournamentDivisions: Option[] = [
  {name: 'little-giants', value: 'LITTLE_GIANTS'},
  {name: 'big-giants', value: 'BIG_GIANTS'},
];